import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
/**
 * @extends {React.Component<import('./types').DataGridViewPaginationTile>}
 */

var PaginationTile =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PaginationTile, _React$Component);

  function PaginationTile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PaginationTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PaginationTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChangePage = function (e) {
      _this.props.onChangePage(e, _this.props.page);
    };

    _this.onKeyPress = function (e) {
      if (e.key === 'Enter') _this.props.onChangePage(e, _this.props.page);
    };

    return _this;
  }

  _createClass(PaginationTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styling = _this$props.styling,
          page = _this$props.page,
          children = _this$props.children,
          onChangePage = _this$props.onChangePage,
          rest = _objectWithoutProperties(_this$props, ["styling", "page", "children", "onChangePage"]);

      var gridStyling = styling.grid;
      var spanStyling = styling.span;
      return React.createElement(Grid, Object.assign({
        item: true,
        className: gridStyling,
        onClick: this.onChangePage,
        tabIndex: 0,
        onKeyPress: this.onKeyPress
      }, rest), React.createElement("span", {
        className: spanStyling
      }, typeof page === 'number' ? page + 1 : children));
    }
  }]);

  return PaginationTile;
}(React.Component);

export default PaginationTile;